import vue from "vue";
import vuex from "vuex";
import VuexPersistence from "vuex-persist";
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});
// 授权
import { vuexOidcCreateStoreModule } from "vuex-oidc";
import { oidcSettings, oidcSettingsWeibo, oidcSettingsFacebook, oidcSettingsTwitter, oidcSettingsLinkedIn } from "../utils/oidc";
// 授权 end

import config from "../../static/config.json";
// // 组件Module
import commonModule from "./module/common"; // 通用module
import wxShare from "./module/wxShare";
import login from "./module/login"; // 登录
import company from "./module/company"; // 公司信息
import linkTo from "./module/linkTo"; // 路由跳转
import my from "./module/my"; // 我的页面相关
import follower from "./module/follower"; // 关注
import connection from "./module/connection"; // 人脉
import upload from "./module/upload"; // 上传
import live from "./module/live"; // 直播
import img from "./module/img"; // 图片样式
import zsReq from "./module/zsReq"; // 展商列表
import act from "./module/act"; // 活动详情
import topicSupply from "./module/topicSupply";
import hall from "./module/hall"; // 展位图
import wxPay from "./module/wxPay"; // 微信支付
import en from "./module/en"; // 英文
import talk from "./module/talk"; //
import set from "./module/set"; //
const Modele = {
  login,
  my,
  wxShare,
  company,
  linkTo,
  follower,
  connection,
  upload,
  live,
  zsReq,
  act,
  topicSupply,
  hall,
  wxPay,
  talk,
  set,
  en,
};

let https = config.https;
vue.use(vuex);

export default new vuex.Store({
  state: {
    ...commonModule.state,
    ...img.state, // 公共的img处理
    isWeixin: false, // 是否为微信环境
    redirectUrl: "", // 授权后重定向地址
    hasAuth: false,
    config: null,
    isCurMobile: true, // 当前展商秀是手机端
    wxConfig: null, //微信分享配置
    api: null,
    login: null, // 登录状态
    auth: null, // token信息
    url: null, // 首次进入的url
    liveUrl: null, // 直播地址
    access_token: "", // 请求token
    expires_in: 0, //在线人数
    roomInfo: "", // 房间信息
    userInfo: "", // 用户用户信息
    hostInfo: "", // 主办用户信息
    exhibitionId: "", // 展会id
    exhibitionInfo: "", // 展会信息
    exhibitionConfig: "", // 展会设置
    userId: "", // 用户id
    inMemberId: "", // 观众信息Id 修改部分观众信息时用到
    viewer: "", //直播间观众信息
    viewerId: "", //直播间观众ID
    userRole: "", // 0：游客、1：普通买家、2：专业买家、3：行业名人、4：展商
    isFollow: false, // 观众是否关注展会
    roomid: "", // 直播间id
    openLiveInfo: "", // 直播间状态 信息
    liveCode: "", // 直播间状态 HasOpenLiveCode  0：未播、1：直播中、2：暂停中、3：已结束、4：已被下架、5：未审核通过、6：审核中
    isHasGetUser: false, // 默认没有授权
    // vuex 重写部分
    ReachBottom: true, //是否触发上拉加载
    // 搜索
    navHeight: "", //自定义导航的高度
    navLeft: "", //自定义导航的左侧距离
    isFooterBtnShow: false, //父组件监听子组件值变化改变z-index
    header: "",
    formHeaders: {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    },
    tokenHeaders: "",
    category: "", // 展品类别
    relepase: "", //话题
    langOpt: {
      icon: "https://img.zhanshangxiu.com/showonline/file/202007/c81a579e0ccc4e2fb6ba159457a10478.jpg",
      lang: "zh",
      name: "中文",
      nameEn: "China",
      shortNameEn: "zh",
      shortNmae: "中文",
      showIndex: 1,
    },
    headTab: "news", // 头条的顶部菜单栏
    myTrackHead: "pro", //我的-足迹页面 顶部菜单栏
    myCollectHead: 0, //我的-关注页面 顶部菜单栏 0 1 2 3
    myActivityHead: 0, //我的-活动页面 顶部菜单栏 0 1
    myLiveHead: 0, //我的-直播页面 顶部菜单栏 0 1
    myMessageHead: "all", //我的-消息页面 顶部菜单栏
    myContactsHead: 0, //我的-人脉页面 顶部菜单栏 0 1 2
    myBusinessHead: 0, //我的-商机页面 顶部菜单栏 0 1
    myTopicHead: 0, //我的-商机页面 顶部菜单栏 0 1
    myTalksHead: 0, //我的-预约洽谈 顶部菜单栏 0 1
    regOrigin: null, // 注册来源
    country: "", // 国家地区数据。
    talkMsgCount: 0, //talk新消息
    myAdvisorySetting: null,
  },
  getters: {
    ...commonModule.getters,
    getIsWeixin: (state) => {
      // 判断是否为微信环境
      return state.isWeixin;
    },
    getTalkMsgCount: (state) => {
      // talk新消息
      return state.talkMsgCount;
    },
    getMyTalksHead: (state) => {
      return state.myTalksHead;
    },
    getToken: (state) => {
      // 判断本地是否含有token 是否过期
      // if(state.access_token){
      //   return 'eyJhbGciOiJSUzI1NiIsImtpZCI6IkU2RkNGQjVGMjBEODAyOERCQTFGOEMzRTJDNUI2RDQ5IiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2MTQwNDQ2NzMsImV4cCI6MTYxNTI1NDI3MywiaXNzIjoiaHR0cHM6Ly9hdXRoLnpoYW5zaGFuZ3hpdS5jb20iLCJhdWQiOlsiYm1tLWFwaSIsInNob3dvbmxpbmUtYXBpIl0sImNsaWVudF9pZCI6InN5bmFpci1zaG93b25saW5lLWpzIiwic3ViIjoiMzZmYzNkOGUtZWNlNi00NGU3LTkyZGMtZjM3MTBlZDA4MTIyIiwiYXV0aF90aW1lIjoxNjE0MDQ0NjczLCJpZHAiOiJsb2NhbCIsImlhdCI6MTYxNDA0NDY3Mywic2NvcGUiOlsiYWRkcmVzcyIsImJtbS1hcGkiLCJlbWFpbCIsIm9wZW5pZCIsInBob25lIiwicHJvZmlsZSIsInNob3dvbmxpbmUtYXBpIl0sImFtciI6WyJlbWFpbCJdfQ.ItdRyJMoBCvMeELqWg_kNzztoN6op7dsMIWOv9Ik2qNR3F85aZ1wN71PAAhpFLU3WwvwNsM97LYpjbf0lqZlFVzY5R1HXmNSVBWklrmIG-Xjd8PqFiszlyoWsL_HXf-qAIbXTHpqjNEMrBbG_MxL0xXSeTnYKTG-j7ggvj9GoR6rbRqZYuzq-g4U65k_DwtNy9p12Kpn7PuqMoI0xsKBlAfhkZgK6_w2jk2T1VvjsxQj9V9pid9m24QipgHgv6LEmf1TVoPEbPhOVDZXzLF3MsAo89v9WqT4vCPb8lO2IiSU5pfXjdLHxiqSeFhCVAhig8IC0WnW_ikYLftlCEdf_Q'
      // }
      return state.access_token;
      // return 'eyJhbGciOiJSUzI1NiIsImtpZCI6IkU2RkNGQjVGMjBEODAyOERCQTFGOEMzRTJDNUI2RDQ5IiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2MTQwNDQ2NzMsImV4cCI6MTYxNTI1NDI3MywiaXNzIjoiaHR0cHM6Ly9hdXRoLnpoYW5zaGFuZ3hpdS5jb20iLCJhdWQiOlsiYm1tLWFwaSIsInNob3dvbmxpbmUtYXBpIl0sImNsaWVudF9pZCI6InN5bmFpci1zaG93b25saW5lLWpzIiwic3ViIjoiMzZmYzNkOGUtZWNlNi00NGU3LTkyZGMtZjM3MTBlZDA4MTIyIiwiYXV0aF90aW1lIjoxNjE0MDQ0NjczLCJpZHAiOiJsb2NhbCIsImlhdCI6MTYxNDA0NDY3Mywic2NvcGUiOlsiYWRkcmVzcyIsImJtbS1hcGkiLCJlbWFpbCIsIm9wZW5pZCIsInBob25lIiwicHJvZmlsZSIsInNob3dvbmxpbmUtYXBpIl0sImFtciI6WyJlbWFpbCJdfQ.ItdRyJMoBCvMeELqWg_kNzztoN6op7dsMIWOv9Ik2qNR3F85aZ1wN71PAAhpFLU3WwvwNsM97LYpjbf0lqZlFVzY5R1HXmNSVBWklrmIG-Xjd8PqFiszlyoWsL_HXf-qAIbXTHpqjNEMrBbG_MxL0xXSeTnYKTG-j7ggvj9GoR6rbRqZYuzq-g4U65k_DwtNy9p12Kpn7PuqMoI0xsKBlAfhkZgK6_w2jk2T1VvjsxQj9V9pid9m24QipgHgv6LEmf1TVoPEbPhOVDZXzLF3MsAo89v9WqT4vCPb8lO2IiSU5pfXjdLHxiqSeFhCVAhig8IC0WnW_ikYLftlCEdf_Q'
    },
    getUserInfo: (state) => {
      // 获取用户信息
      return state.userInfo || "";
    },
    getHostInfo: (state) => {
      // 获取主办信息
      return state.hostInfo;
    },
    getUserId: (state) => {
      // 获取用户信息
      return state.userId;
    },
    getInMemberId: (state) => {
      // 获取观众信息Id
      return state.inMemberId;
    },
    getViewerId: (state) => {
      // 获取直播间观众ID
      return state.viewerId;
    },
    getViewer: (state) => {
      // 获取直播间观众信息
      return state.viewer;
    },
    getReachBottom: (state) => {
      // 获取是否上拉刷新
      return state.ReachBottom;
    },
    getNavHeight: (state) => {
      // 获取自定义导航的高度
      return state.navHeight;
    },
    getNavLeft: (state) => {
      // 获取自定义导航的左侧距离
      return state.navLeft;
    },
    getIsFooterBtnShow: (state) => {
      // 获取footer z-index;
      return state.isFooterBtnShow;
    },
    getUserRole: (state) => {
      return state.userRole;
    },
    getIsHasGetUser: (state) => {
      return state.isHasGetUser;
    },
    getRoomid: (state) => {
      return state.roomid;
    },
    getApi: (state) => {
      return state.api;
    },
    getRoomInfo: (state) => {
      return state.roomInfo;
    },
    getIsFollow: (state) => {
      return state.isFollow;
    },
    getExhibitionInfo: (state) => {
      return state.exhibitionInfo;
    },
    getExhibitionConfig: (state) => {
      return state.exhibitionConfig;
    },
    getConfigLogoIsSquare: (state) => {
      //展商logo是否是方形
      if (state.exhibitionConfig) {
        return state.exhibitionConfig.display.exhibitorWapLogo == "SQUARE";
      } else {
        return false;
      }
      console.log(state.exhibitionConfig, "展会信息啊");
    },
    getExhibitionId: (state) => {
      return state.exhibitionId;
    },
    getOpenLiveInfo: (state) => {
      return state.openLiveInfo;
    },
    getLiveCode: (state) => {
      return state.liveCode;
    },
    getLogin: (state) => {
      return state.login;
    },
    getAuth: (state) => {
      return state.auth;
    },
    getExpiresin: (state) => {
      return state.expires_in;
    },
    getHasAuth: (state) => {
      return state.hasAuth;
    },
    getWxConfig: (state) => {
      return state.wxConfig;
    },
    getRedirectUrl: (state) => {
      return state.redirectUrl;
    },
    getLiveUrl: (state) => {
      return state.liveUrl;
    },
    getCategory: (state) => {
      return state.category;
    },
    getHeadTab: (state) => {
      return state.headTab;
    },
    getMyTrackHead: (state) => {
      return state.myTrackHead;
    },
    getMyCollectHead: (state) => {
      return state.myCollectHead;
    },
    getMyActivityHead: (state) => {
      return state.myActivityHead;
    },
    getMyLiveHead: (state) => {
      return state.myLiveHead;
    },
    getMyMessageHead: (state) => {
      return state.myMessageHead;
    },
    getMyContactsHead: (state) => {
      return state.myContactsHead;
    },
    getMyBusinessHead: (state) => {
      return state.myBusinessHead;
    },
    getMyTopicHead: (state) => {
      return state.myTopicHead;
    },

    setRelepase: (state) => {
      return state.relepase;
    },
    getLangOpt: (state) => {
      return state.langOpt || localStorage.getItem("langOpt");
    },
    getRegOrigin: (state) => {
      return state.regOrigin;
    },
    getCountry: (state) => {
      return state.country;
    },

    getExhibitorsLoadProductNumber: (state) => {
      let bool = 5;
      if (state.exhibitionConfig && state.exhibitionConfig.exhibitorsLoadProductNumber) {
        bool = state.exhibitionConfig.exhibitorsLoadProductNumber;
      }
      return bool;
    },
    getMyAdvisorySetting: (state) => {
      return state.myAdvisorySetting;
    },
  },
  mutations: {
    ...commonModule.mutations,
    setIsWeixin(state, data) {
      // 设置是否为微信环境
      state.isWeixin = data;
    },
    setToken(state, data) {
      localStorage.setItem("access_token", data);
      if (data) {
        state.tokenHeaders = {
          headers: {
            Authorization: "Bearer " + data,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        };
        state.header = {
          headers: {
            Authorization: "Bearer " + data,
            "Content-Type": "application/json; charset=UTF-8;",
          },
        };
      }
      state.hasAuth = true;
      state.access_token = data;
    },
    setUserInfo(state, data) {
      // 设置用户信息
      localStorage.setItem("userInfo", JSON.stringify(data));
      state.userInfo = data;
    },
    setHostInfo(state, data) {
      // 设置用户信息
      localStorage.setItem("hostInfo", JSON.stringify(data));
      state.hostInfo = data;
    },
    setRelepase(state, data) {
      // 设置话题选择
      localStorage.setItem("replepase", JSON.stringify(data));
      state.hostInfo = data;
    },
    setViewerId(state, data) {
      // 设置直播间观众Id
      state.viewerId = data;
    },
    setTalkMsgCount(state, data) {
      // 设置新消息
      state.talkMsgCount = data;
    },
    setViewer(state, data) {
      // 设置直播间观众信息
      state.viewer = data;
    },
    setSearch(state, data) {
      // 设置搜索内容
      state.search = data;
    },
    setNavHeight(state, data) {
      // 设置自定义导航;
      state.navHeight = data;
    },
    setNavLeft(state, data) {
      // 设置自定义导航左侧距离;
      state.navLeft = data;
    },
    setIsFooterBtnShow(state, data) {
      // 设置footer z-index;
      state.isFooterBtnShow = data;
    },
    setUserRole(state, data) {
      state.userRole = data;
    },
    setIsHasGetUser(state, data) {
      state.isHasGetUser = data;
    },
    setRoomId(state, data) {
      state.roomid = data;
    },
    setConfig(state, data) {
      state.config = data;
      state.api = data.https;
    },
    setWxConfig(state, data) {
      state.wxConfig = data;
    },
    setRoomInfo(state, data) {
      state.roomInfo = data;
    },
    setUserId(state, data) {
      state.userId = data;
    },
    setInMemberId(state, data) {
      state.inMemberId = data;
    },
    setIsFollow(state, data) {
      state.isFollow = data;
    },
    setExhibitionInfo(state, data) {
      state.exhibitionInfo = data;
    },
    setExhibitionConfig(state, data) {
      state.exhibitionConfig = data;
    },
    setExhibitionId(state, data) {
      state.exhibitionId = data || "B20F046C-0F1F-4A55-867C-049910221B83";
    },
    setOpenLiveInfo(state, data) {
      state.openLiveInfo = data;
    },
    setLiveCode(state, data) {
      state.liveCode = data;
    },
    setLogin(state, data) {
      state.login = data;
    },
    setAuth(state, data) {
      state.auth = data;
    },
    setExpiresIn(state, data) {
      state.expires_in = data;
    },
    setUrl(state, data) {
      state.url = data;
    },
    setRedirectUrl(state, data) {
      state.redirectUrl = data;
    },
    setLivetUrl(state, data) {
      state.liveUrl = data;
    },
    setCategory(state, data) {
      state.category = data;
    },
    setHeadTab(state, data) {
      state.headTab = data;
    },
    setMyTrackHead(state, data) {
      state.myTrackHead = data;
    },
    setMyCollectHead(state, data) {
      state.myCollectHead = data;
    },
    setMyActivityHead(state, data) {
      state.myActivityHead = data;
    },
    setMyLiveHead(state, data) {
      state.myLiveHead = data;
    },
    setMyMessageHead(state, data) {
      state.myMessageHead = data;
    },
    setMyContactsHead(state, data) {
      state.myContactsHead = data;
    },
    setMyBusinessHead(state, data) {
      state.myBusinessHead = data;
    },
    setMyTopicHead(state, data) {
      state.myTopicHead = data;
    },
    setLangOpt(state, data) {
      state.langOpt = data;
      localStorage.setItem("langOpt", JSON.stringify(data));
    },
    setRegOrigin(state, data) {
      state.regOrigin = data;
    },
    setCountry(state, data) {
      state.country = data;
    },
    setMyTalksHead(state, data) {
      state.myTalksHead = data;
    },
    setMyAdvisorySetting(state, data) {
      state.myAdvisorySetting = data;
    },
  },
  actions: {
    ...commonModule.actions,
  },
  modules: {
    ...Modele,
    oidcStore: vuexOidcCreateStoreModule(
      oidcSettings,
      // Optional OIDC store settings
      {
        // namespaced: true,
        publicRoutePaths: [
          "/live-test",
          "/silentSignInCallback",
          // '/home'
        ], // 设置不需要授权的页面
        dispatchEventsOnWindow: true,
      }
    ),
    oidcStoreWeibo: vuexOidcCreateStoreModule(oidcSettingsWeibo, {
      namespaced: true,
    }),
    oidcStoreFacebook: vuexOidcCreateStoreModule(oidcSettingsFacebook, {
      namespaced: true,
    }),
    oidcStoreTwitter: vuexOidcCreateStoreModule(oidcSettingsTwitter, {
      namespaced: true,
    }),
    oidcStoreLinkedIn: vuexOidcCreateStoreModule(oidcSettingsLinkedIn, {
      namespaced: true,
    }),
  },
  plugins: [vuexLocal.plugin],
});
